import { memo, useCallback, useMemo } from 'react'
import './index.scss'
import MaintenanceInstance from '../MaintenanceInstance'
import { useQuery } from 'react-query'
import { getMaintenanceMobile, getServiceBase, getServiceInstance } from '../../../services/calls/maintenance'
import { DTO_MaintenanceBase, DTO_ServiceBase } from '../../../services/calls/types/maintenance'

type CarMaintenance = {
  mobile: DTO_MaintenanceBase
}

const EMPTY_INSTANCE = {
  headers: [],
  records: []
}

export const SINGLE_BASE = 'ES' // Hard coded in backend for single base instances

const CarMaintenance = memo(({ mobile }: CarMaintenance) => {
  const { data: milageInstances, refetch: fetchMilages, isLoading: milageIsLoading } = useQuery(`getMaintenanceMobileMilage_${mobile.id}`, () => getMaintenanceMobile(mobile.id))
  const { data: dateInstances, refetch: fetchDates, isLoading: dateIsLoading } = useQuery(`getMaintenanceMobileDate_${mobile.id}`, () => getMaintenanceMobile(mobile.id, true))
  const { data: instances, refetch: fetchInstances, instancesIsLoading } = useQuery(`getInstances_${mobile.id}`, () => getServiceInstance())
  const { data: bases, refetch: fetchBases, basesIsLoading } = useQuery(`getServiceBases_${mobile.id}`, () => getServiceBase(mobile.id))

  const baseLookup = useMemo(() => {
    const lookup: Record<number, DTO_ServiceBase> = {}
    if (bases) {
      bases.forEach((base) => {
        lookup[base.id] = base
      })
    }
    return lookup
  }, [bases])

  const singleInstances = useMemo(() => {
    if (bases && instances) {
      const ids = bases?.reduce((arr, b) => {
        if (b.description === SINGLE_BASE) arr.push(b.id)
        return arr
      }, [] as number[])
      return instances?.filter((instance) => ids.includes(instance.service)) ?? []
    }
    return []
  }, [bases, instances])

  const refetchScheduled = useCallback(async () => {
    await fetchMilages()
    await fetchDates()
  }, [fetchMilages, fetchDates])

  return (
    <div className="CarMaintenance">
      <MaintenanceInstance
        type="milage"
        data={milageInstances ?? EMPTY_INSTANCE}
        mobile={mobile}
        bases={baseLookup}
        refetch={() => refetchScheduled()}
        refetchBases={() => fetchBases()}
        isLoading={milageIsLoading || basesIsLoading}
      />
      <MaintenanceInstance
        type="date"
        data={dateInstances ?? EMPTY_INSTANCE}
        mobile={mobile}
        bases={baseLookup}
        refetch={() => refetchScheduled()}
        refetchBases={() => fetchBases()}
        isLoading={dateIsLoading || basesIsLoading}
      />
      <MaintenanceInstance
        type="single"
        data={singleInstances}
        mobile={mobile}
        bases={baseLookup}
        refetch={() => fetchInstances()}
        refetchBases={() => fetchBases()}
        isLoading={instancesIsLoading}
      />
    </div>
  )
})

export default CarMaintenance
